/** Field lock flags for create / edit / duplicate incentive forms. */
export type IncentiveNotEditableFlags = { [field: string]: boolean };

export function startOfLocalDay(d: Date): Date {
  const copy = new Date(d);
  copy.setHours(0, 0, 0, 0);
  return copy;
}

/** Not-yet-started edits (and inactive Adhoc) may change the micro-corridor. */
export function corridorEditableOnEdit(
  defaultValue: { startDate?: string; incentiveType?: string; active?: boolean } | null | undefined,
  today: Date,
): boolean {
  if (!defaultValue || !defaultValue.startDate) {
    return false;
  }
  if (defaultValue.incentiveType === 'Adhoc') {
    return !defaultValue.active;
  }
  if (defaultValue.incentiveType === 'Weekly Fixed') {
    return false;
  }
  const incentiveStartDay = startOfLocalDay(new Date(defaultValue.startDate));
  const todayStart = startOfLocalDay(today);
  return incentiveStartDay.getTime() > todayStart.getTime();
}

/**
 * Version stays locked on edit and duplicate (v1 cannot become v2, and the reverse).
 * On edit, payout type and the MC checkbox stay locked too. The corridor itself stays
 * editable only while the incentive has not started.
 */
export function applyEditImmutableContract(
  state: string,
  editState: string,
  duplicateState: string,
  notEditable: IncentiveNotEditableFlags,
  defaultValue: { startDate?: string; incentiveType?: string; active?: boolean } | null | undefined,
  today: Date,
): void {
  if (state !== editState && state !== duplicateState) {
    return;
  }
  notEditable.incentiveVersion = true;
  if (state !== editState) {
    return;
  }
  notEditable.payoutType = true;
  notEditable.isMCIncentive = true;
  if (!corridorEditableOnEdit(defaultValue, today)) {
    notEditable.selectedMicroCorridorId = true;
  }
}

/** Duplicate clones the source but behaves like create: all fields editable except v1/v2 lock. */
export function applyDuplicateNotEditable(notEditable: IncentiveNotEditableFlags): void {
  Object.keys(notEditable).forEach((fieldName) => {
    notEditable[fieldName] = false;
  });
  notEditable.incentiveVersion = true;
}
